<template>
  <v-container class="pa-0">
    <v-text-field
      type="text"
      label="Förnamn*"
      outlined
      v-model="data.firstname"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="20"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Efternamn*"
      outlined
      v-model="data.lastname"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="20"
    ></v-text-field>
    <v-text-field
      type="text"
      label="Mobilnummer*"
      outlined
      v-model="data.mobile"
      :rules="[formRules.required]"
      validate-on-blur
      required
      maxlength="20"
    ></v-text-field>
    <v-text-field
      type="email"
      label="E-postadress*"
      outlined
      v-model="data.email"
      :rules="[formRules.required,formRules.email]"
      validate-on-blur
      required
      maxlength="50"
    ></v-text-field>
  </v-container>
</template>

<script>
import { generalMixin } from '../mixins/general'

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mixins: [generalMixin]
}
</script>

<style>

</style>